export default __webpack_public_path__ + "static/media/loading-circle.2c362091.svg";